module.exports = __webpack_public_path__ + "static/media/IMG_0612.443ef776.jpg";